import React, { Component, Fragment } from 'react';
import Label from '../../../components/atoms/Label';
import LabelWithText from '../../../components/molecules/LabelWithText';
import LabelWithBtn from '../../../components/molecules/LabelWithBtn';
import {browserHistory} from 'react-router'
import dateFormatIndo from '../../../utils/helpers/dateFormatIndo';

export default ({ title, infoDocs }) => {
  let col = { label : 'col-md-3', text : 'col-md-9' }
  console.log('====================================');
  console.log({ infoDocs });
  console.log('====================================');
  let LR = infoDocs.find((element) => {
    return element.documentType === 'LR0';
  })
  let Keuangan = infoDocs.find((element) => {
    return element.documentType === 'LKU';
  })
  return(
    <div>
        <Label value={title} className='label-menu'/>
        <div>
          {/* {
            infoDocs.map((value, index) => {
              if( value.documentType === 'LR0' || value.documentType === 'LKU' ){
                return(
                  <Fragment key = {index}>
                    {
                      index !== 0 && <hr className='border-dashed add-margin' />
                    }
                    <p>{JSON.stringify(value)}</p>
                    <LabelWithText label = {value.documentTypeName} text = {value.documentNumber} col={col} />
                    {
                      value.documentBeginDate && (
                        <LabelWithText label = {`Tgl. Pendaftaran ${value.documentTypeName}`} text = { dateFormatIndo(value.documentBeginDate, 'long') } col={col} />
                      )
                    }
                    {
                      value.documentEndDate && (
                        <LabelWithText label = {`Tgl. Berakhir ${value.documentTypeName}`} text = { dateFormatIndo(value.documentEndDate, 'long') } col={col} />
                      )
                    }
                    {
                      value.documentFileUrl ? (
                        <LabelWithBtn label = {''} col={col} url={value.documentFileUrl} />
                      ) : (
                        <LabelWithBtn isDisabled label = {''} col={col}/>
                      )
                    }

                  </Fragment>
                )
              }
            })
          } */}
          {
            LR.documentFileUrl ? (
              <LabelWithBtn label = {LR.documentTypeName} col={col} url={LR.documentFileUrl} />
            ) : (
              <LabelWithBtn isDisabled label = {LR.documentTypeName} col={col}/>
            )
          }
          {
            Keuangan.documentFileUrl ? (
              <LabelWithBtn label = {Keuangan.documentTypeName} col={col} url={Keuangan.documentFileUrl} />
            ) : (
              <LabelWithBtn isDisabled label = {Keuangan.documentTypeName} col={col}/>
            )
          }
          {/* <LabelWithBtn label = {LR.documentTypeName} col={col} />
          <LabelWithBtn label = {'Akta Perubahan'} col={col} /> */}
        </div>
    </div>
  )
}